import { render, staticRenderFns } from "./FPageStuckProducts.vue?vue&type=template&id=fb4d544c&"
import script from "./FPageStuckProducts.vue?vue&type=script&lang=js&"
export * from "./FPageStuckProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports